import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { WellnessService } from 'src/app/services/wellness.service';
import * as moment from 'moment';

@Component({
  selector: 'vex-change-challenge',
  templateUrl: './change-challenge.component.html',
  styleUrls: ['./change-challenge.component.scss']
})
export class ChangeChallengeComponent implements OnInit {
  challengeInfos;

  constructor(private router: Router, public guiService: GuiService, public translate: TranslateService, public restService: RestService, public wellnessSrv: WellnessService) { }

  ngOnInit(): void {
    if(this.guiService.lastAcceptedChallenge){
      this.getTimeChallenges();
      this.blockAllVideos();
    }else{
      this.myBackButton();
    }
  }

  myBackButton() {
    this.router.navigate(['main/home']);
  }

  getTimeChallenges() {
    const param = { page: 0, size: 1, filterAnd: [{ field: "i18nName.IT", operator: "eq", value: "SFIDA A TEMPO" }] };
    this.guiService.showSpinner = true;
    this.restService.postService('category', '/search?ALL_LANGUAGES=true', param).subscribe({
      next: (ris) => {
        this.challengeInfos = ris.items[0];
        this.guiService.showSpinner = false;
      }, error: () => {
        this.guiService.showSpinner = false;
      }
    })
  }

  changeChallenge(){
    this.router.navigate(['main/select-challenge'],{ state: { 'bannerCategory': JSON.stringify(this.challengeInfos) }})
  }

  videoDetail(video, categoryName) {
    this.wellnessSrv.videoSelected = video;
    this.wellnessSrv.categoryName = categoryName;

    setTimeout(() => {
        this.router.navigate(['/main/ondemand-video-detail'], { replaceUrl: true })
    }, 200);
  }

  blockAllVideos(){
    //BLOCCA TUTTI I VIDEO SE LA CHALLANGE ANCORA NON E' INIZIATA
    const today = moment().format('YYYY-MM-DD');
    const publishDate = moment(this.guiService.lastAcceptedChallenge.videos[0].publishDate, 'unix').format('YYYY-MM-DD');
      if (moment(today).isBefore(publishDate)){
      this.guiService.lastAcceptedChallenge.videos.forEach(video => {
        video.videoBlocked = true;
      });
    }
  }

}
